import { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = HTMLAttributes<HTMLDivElement>;

export const Divider: FC<Props> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <div className={twMerge('relative min-h-24', className)} {...rest}>
      <div className="absolute w-full top-1/2 -translate-y-1/2 h-[1px] border-t-2 border-dotted border-primary50 rounded-full" />

      {children && (
        <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 bg-grayscale0 px-24">
          {children}
        </div>
      )}
    </div>
  );
};
